import React from "react";
import { Link } from "react-router-dom";
import logo from "../images/img-1.png";

export default function Footer({
  onHomeClick,
  onContactClick,
  onSerendipityClick,
}) {
  const handleSerendipityClick = (event) => {
    if (!onSerendipityClick) return;

    event.preventDefault();
    onSerendipityClick();
  };

  return (
    <footer className="mt-6" style={{ backgroundColor: "#F6FBFD" }}>
      <div className="mx-auto max-w-7xl px-4 pb-10 pt-14 sm:px-6 lg:px-10">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          {/* Brand */}
          <div>
            <img src={logo} className="h-11 w-auto" alt="BSI" />
            <p className="mt-4 max-w-xs text-sm font-medium leading-6 text-slate-500">
              Goal Tracking Software designed for discovery, not pressure. Mining the future through
              serendipity.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <div className="text-sm font-bold text-slate-900">Quick Links</div>
            <div className="mt-4 space-y-3 text-sm font-medium text-slate-500">
              <Link to="/" onClick={onHomeClick} className="block hover:text-cyan-600">
                Home
              </Link>
              <Link to="/#features" className="block hover:text-cyan-600">
                Features
              </Link>
              <Link to="/blogs" className="block hover:text-cyan-600">
                Blog
              </Link>
              <Link to="/#contact" onClick={onContactClick} className="block hover:text-cyan-600">
                Contact
              </Link>
            </div>
          </div>

          {/* Resources */}
          <div>
            <div className="text-sm font-bold text-slate-900">Resources</div>
            <div className="mt-4 space-y-3 text-sm font-medium text-slate-500">
              <span className="block">Goal Setting App</span>
              <span className="block">Progress Tracking</span>
              <Link
                to="/#serendipity"
                onClick={handleSerendipityClick}
                className="block hover:text-cyan-600"
              >
                Serendipity Engine
              </Link>
              <span className="block">Reports &amp; Insights</span>
            </div>
          </div>

          {/* Contact */}
          <div>
            <div className="text-sm font-bold text-slate-900">Contact</div>
            <div className="mt-4 space-y-3 text-sm font-medium text-slate-500">
              <div className="flex items-start gap-3">
                <span className="mt-0.5 text-cyan-500">
                  <svg viewBox="0 0 24 24" fill="none" className="h-4 w-4" stroke="currentColor" strokeWidth="2">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.08 4.18 2 2 0 0 1 4.06 2h3a2 2 0 0 1 2 1.72c.12.86.3 1.7.54 2.5a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.58-1.06a2 2 0 0 1 2.11-.45c.8.24 1.64.42 2.5.54A2 2 0 0 1 22 16.92z" />
                  </svg>
                </span>
                <span>+31 6 16652615</span>
              </div>
              <div className="flex items-start gap-3">
                <span className="mt-0.5 text-cyan-500">
                  <svg viewBox="0 0 24 24" fill="none" className="h-4 w-4" stroke="currentColor" strokeWidth="2">
                    <path d="M4 4h16v16H4z" opacity=".1" />
                    <path d="M4 4h16v16H4z" />
                    <path d="m4 7 8 6 8-6" />
                  </svg>
                </span>
                <span>info@blueskyindex.com</span>
              </div>
              <div className="flex items-start gap-3">
                <span className="mt-0.5 text-cyan-500">
                  <svg viewBox="0 0 24 24" fill="none" className="h-4 w-4" stroke="currentColor" strokeWidth="2">
                    <path d="M21 10c0 6-9 12-9 12S3 16 3 10a9 9 0 1 1 18 0Z" />
                    <path d="M12 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
                  </svg>
                </span>
                <span>Netherlands</span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 h-px w-full bg-slate-200/70" />

        <div className="mt-6 flex flex-col gap-4 text-sm font-medium text-slate-500 sm:flex-row sm:items-center sm:justify-between">
          <div>© 2026 Blue Sky Index. All rights reserved.</div>
          <div className="flex items-center gap-6">
            <Link to="/privacy-policy" className="hover:text-cyan-600">
              Privacy Policy
            </Link>
            <Link to="/terms-and-conditions" className="hover:text-cyan-600">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

